import React, { useState } from "react";
import api, { apiErrorMessage } from "../lib/api";

export function messagingText(delivery) {
  if (!delivery) return "Notification status has not been recorded for this appointment.";
  if (delivery.retry_in_progress) return "A notification retry is in progress or needs review. Do not resend; check with the clinic.";
  if (delivery.status === "sent") return "Notification accepted by the messaging provider. Inbox delivery is not yet confirmed.";
  if (delivery.status === "partial") return "One notification channel succeeded; another did not. Your appointment remains saved.";
  if (delivery.status === "provider_unconfigured") return "Notification could not be sent because messaging is not configured. Your appointment remains saved; contact the clinic if needed.";
  if (delivery.status === "skipped") {
    if (delivery.reason === "consent_opt_out") return "Notifications are turned off for this patient. Your appointment remains saved.";
    if (delivery.reason === "no_contact_details" || delivery.reason === "patient_unavailable") return "No notification was sent because contact details are unavailable. Your appointment remains saved.";
    return "No notification was sent. Your appointment remains saved.";
  }
  return "Notification delivery could not be confirmed. Your appointment remains saved. Check with the clinic before resending or booking again.";
}

export function AppointmentMessagingStatus({ delivery, appointmentId, canRetry = false, onUpdated }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const retry = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/appointments/${appointmentId}/notifications/retry`);
      onUpdated?.(data);
    } catch (e) { setError(apiErrorMessage(e, "Could not confirm retry status. Refresh before trying again.")); }
    finally { setBusy(false); }
  };
  return <section className="rounded-xl border border-slate-200 bg-slate-50 p-3 my-3 text-sm" aria-label="Appointment notifications">
    <p role="status">{messagingText(delivery)}</p>
    {delivery?.channels?.length > 0 && <ul className="mt-2 text-xs text-slate-600">
      {delivery.channels.map((c) => <li key={c.channel}>{c.channel === "email" ? "Email" : "SMS"}: {c.status === "sent" ? "Accepted by provider" : c.status === "unconfigured" ? "Not configured" : c.status === "skipped" ? "Not sent" : "Delivery unconfirmed"}</li>)}
    </ul>}
    {delivery?.channels?.some(c => c.log_persisted === false) && <p className="mt-2 text-xs">Delivery history could not be saved. Check with the clinic before resending.</p>}
    {canRetry && delivery?.retryable && !delivery.retry_in_progress && <div className="mt-3">
      <p className="text-xs mb-2">Check provider settings first. Only channels that were not sent will be retried, after a 60-second wait.</p>
      <button type="button" className="mg-btn-secondary" disabled={busy} onClick={retry}>{busy ? "Retrying…" : "Retry unsent notification"}</button>
    </div>}
    {error && <p role="alert" className="mt-2 text-red-700">{error}</p>}
  </section>;
}
